<template>
  <div class="page" v-cloak>

    <div class="top" v-if="code == 0">
      <div class="icon">
        <!-- <van-icon name="checked" color="#ff5000" /> -->
        <van-loading type="spinner" />
      </div>
      <div class="mt20 title">登录中。。</div>
      <!-- <div class="mt10">如果有问题，请 <span class="contact" @click="makePhoneCall">联系我们</span></div> -->
    </div>

    <div class="top" v-else>
      <div class="icon">
        <van-icon name="clear" color="#C64545" />
      </div>
      <div class="mt20 title">账号不存在！</div>
      <!-- <div class="mt10">如果有问题，请 <span class="contact" @click="makePhoneCall">联系我们</span></div> -->
    </div>

    <div class="btn-block" v-if="code != 0">
      <!-- <div class="btn" @click="goIndex">去登录</div> -->
      <div class="btn btns" @click="goOrder">去注册</div>
    </div>

    <!-- 猜你喜欢 -->
    <!-- <you-like-scroll :arrow="2"></you-like-scroll> -->

  </div>
</template>
  
  <script>
// import youLikeScroll from "@/components/you-like-scroll/you-like-scroll.vue";
export default {
  name: "PayResult",
  components: {
    // youLikeScroll
  },
  props: {},
  data() {
    return {
      // code=0&message=描述&bj_user_id=&bj_openid=&phone=
      // code=0 ,必净会员存在，调用bj_login接口，
      // code<0 , 有错误，message是错误信息
      code: this.$route.query.code || undefined,
      message: this.$route.query.message || undefined,
      bj_user_id: this.$route.query.bj_user_id || undefined,
      bj_open_id: this.$route.query.bj_open_id || undefined,
      phone: this.$route.query.phone || undefined,

      aa: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue)
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    console.log(this.$route.query);
    //   if(this.$route.query.code == -1){
    //       this.$router.replace({ name: "new-bind", query: {} });
    //   }
    if (this.$route.query.code == 0) {
      this.bjdenglu();
    }
  },
  methods: {
    bjdenglu() {
      let _this = this;
      console.log(_this.bj_open_id);
      let data = {
        phone: _this.phone,
        bj_openid: _this.bj_open_id,
        bj_user_id: _this.bj_user_id,
        openid: Lockr.get("openId"), //微信openid
      };
      console.log(data);
      this.$post("/api/bj_login", data, data).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 0) {
          this.$toast.clear(); //关闭弹窗

          _this.$toast({ message: "登陆成功~" });

          Lockr.set("userId", res.data.data.user_id); // uid
          _this.$store.commit("set_user_id", res.data.data.user_id);

          Lockr.set("referral_code", res.data.data.invite_code); // 邀请码
          _this.$store.commit("set_referral_code", res.data.data.invite_code); // 邀请码

          Lockr.set("userInfo", res.data.data); //用户信息

          Lockr.set("mobile", res.data.data.phone_no); // 手机号
          _this.$store.commit("set_Mobile", res.data.data.phone_no);

          this.$router.replace({
            name: "mine",
            query: {
              id: "",
            },
          });
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 返回订单
    goOrder() {
      this.$router.replace({
        name: "new-bind",
        query: {
          id: "",
        },
      });
    },
    // 跳首页
    goIndex() {
      this.$router.replace({
        name: "login",
        query: {
          id: "",
        },
      });
    },
    makePhoneCall() {
      this.MakeCall(); //拨打电话
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding-top: 150px;

  .top {
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }

  .icon {
    width: 85px;
    height: 85px;
    /* background: papayawhip; */
    font-size: 85px;
    margin: 0 auto;
  }

  .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 30px;
    color: #2a2e43;
    letter-spacing: 2.5px;
  }

  .contact {
    color: #3497fd;
  }

  .btn-block {
    /* background-color: #eee; */
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 50px 0;
  }

  .btn {
    width: 130px;
    height: 100%;
    border: 1px solid #707070;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #2a2e43;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 5px;
  }

  .btns {
    border: 1px solid #ff5000;
    color: #ff5000;
  }
}
.top-tips {
  position: fixed;
  top: 46px;
  left: 0;
  width: 100%;
}
</style>
  
  
    